import { Component, OnInit,Input } from '@angular/core';
import { environment } from "../../environments/environment";
import { CartService } from "../services/cart/cart.service";
@Component({
  selector: 'app-card-product',
  templateUrl: './card-product.component.html',
  styleUrls: ['./card-product.component.css']
})
export class CardProductComponent implements OnInit {

  @Input() product:any;
  @Input() promos:any=false;
  contentLoaded
  baseUrl = environment.baseUrl
  card = [];
  favoris = [];
  qte = '1';
  existFavoris;
  typeCompte
  constructor(private cartService:CartService) {
    this.typeCompte = localStorage.getItem('typeCompte');
    if (JSON.parse(localStorage.getItem('card'))!=null && JSON.parse(localStorage.getItem('card'))!=undefined) {
      this.card = JSON.parse(localStorage.getItem('card'));
    }else{
      this.card = [];
    }

    if(localStorage.getItem('favoris')) {
      this.favoris = JSON.parse(localStorage.getItem('favoris'));
    }
  }

  ngOnInit(): void {
  }



  addToCard(product)
  {
    if (JSON.parse(localStorage.getItem('card'))!=null && JSON.parse(localStorage.getItem('card'))!=undefined) {
      this.card = JSON.parse(localStorage.getItem('card'));
    }else{
      this.card = [];
    }

    this.qte = product.DET
    if (this.qte) {
      if (!this.isProduitExistInCard(product.ITMREF)) {

        this.card.push({product:product,item_quantity:parseInt(this.qte)});
        this.cartService.panierCount++;
        this.cartService.addTocart({
          "item_ref" : product.ITMREF,
          "item_quantity" : this.qte,
          "item_price" : product.PRIXNET
        }).subscribe(res=>{
          
        });

      }else{
        this.card.forEach(itemCard => {
          if (product.ITMREF==itemCard.product.ITMREF) {
            itemCard.item_quantity= parseInt(itemCard.item_quantity)+parseInt(this.qte);
            var q = parseInt(itemCard.item_quantity)/parseInt(product.DET)
            itemCard.item_quantity = ''+(parseInt(product.DET)*parseInt(q.toFixed()))
            this.cartService.updateItemCart([{
                "item_ref": product.ITMREF,
                "item_quantity": itemCard.item_quantity
            }]).subscribe(res=>{
              
            })
          }
        });
      }

      
      localStorage.setItem('card', JSON.stringify(this.card));
    }else{
      alert("vous devez remplir la quantité");
    }

  }


  addToFavoris(product)
  {
    if (JSON.parse(localStorage.getItem('favoris'))!=null && JSON.parse(localStorage.getItem('favoris'))!=undefined) {
      this.favoris = JSON.parse(localStorage.getItem('favoris'));
    }else{
      this.favoris = [];
    }
    if (!this.isProduitExistInFavoris(product.ITMREF)) {
        this.favoris.push(product);
        this.existFavoris = true;
        this.cartService.favorisCount++;
    }else{
        alert("Ce produit est déjà dans vos favoris");
    }
    localStorage.setItem('favoris', JSON.stringify(this.favoris));
  }

  isProduitExistInCard(id)
  {
    var exit = false;
    this.card.forEach(item => {
      if (id==item.product.ITMREF) {
        exit =  true;
      }
    });

    return exit;
  }

  isProduitExistInFavoris(id)
  {
    var exit = false;
    this.favoris.forEach(item => {
      if (id==item.ITMREF) {
        exit =  true;
      }
    });

    return exit;
  }

}
